<template>
  <div class="head-card">
    <div class="head-card-top">
      <h4>{{ $t('google_ads.list') }}</h4>
      <feather-icon
        v-b-tooltip.hover.top="$t('Close')"
        icon="XIcon"
        size="18"
        class="toggle-close cursor-pointer"
        @click="$router.go(-1)"
      />
    </div>
    <hr>
    <div class="head-card-bottom pb-1">
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        :variant="isOfferWallActive ? 'primary' : 'light-primary'"
        :to="{ name: 'dashboard-google-ads' }"
        exact
      >
        <feather-icon
          icon="GridIcon"
          size="16"
        />
        {{ $t('google_ads.list') }}
      </b-button>
      <b-button
        v-if="isAdmin"
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        :variant="isProvidersActive ? 'primary' : 'light-primary'"
        :to="{ name: 'dashboard-offerwall-providers' }"
      >
        <feather-icon
          icon="LayersIcon"
          size="16"
        />
        {{ $t('offerwall_providers.title') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  computed: {
    isAdmin() {
      const userData = getUserData() || {}
      const roles = [
        ...(Array.isArray(userData.roles) ? userData.roles : []),
        ...(Array.isArray(userData.role) ? userData.role : []),
        ...(typeof userData.role === 'string' ? [userData.role] : []),
      ].map(role => String(role).toLowerCase())

      return roles.includes('admin')
    },
    isProvidersActive() {
      return this.$route.name.startsWith('dashboard-offerwall-provider')
    },
    isOfferWallActive() {
      return !this.isProvidersActive
    },
  },
}
</script>
